export default "__VITE_ASSET__DV8AUbnR__"